window.theme.component('offer-suggest-form', root => {
	const nonce = window.config && window.config.pechincha_offer_submit_nonce ? window.config.pechincha_offer_submit_nonce : '';
	const msg = root.querySelector('.js-offer-suggest-msg');
	const fetchStatus = root.querySelector('.js-offer-suggest-fetch-status');
	const submitButton = root.querySelector('.offer-suggest-form__submit');
	const urlInput = root.querySelector('.js-offer-suggest-url');
	const imageInput = root.querySelector('.js-offer-suggest-image');
	const titleInput = root.querySelector('[name="title"]');
	const descriptionInput = root.querySelector('[name="description"]');
	const priceInput = root.querySelector('[name="price"]');
	const pricePromoInput = root.querySelector('[name="price_promotional"]');
	const storeInput = root.querySelector('[name="store_name"]');
	const categoryValue = root.querySelector('.js-category-picker-value');
	const categoryLabel = root.querySelector('.js-category-picker-label');
	const categoryOptions = root.querySelectorAll('.js-category-picker-option');
	let fetchTimer = null;

	function setStatus(el, text, isError) {
		if (!el) return;
		el.classList.remove('hidden');
		el.classList.toggle('is-error', !!isError);
		el.textContent = text || '';
	}

	function normalize(text) {
		return (text || '').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
	}

	// Pre-select the closest matching category option, same fuzzy match used
	// by the admin form (server-side names never match a scraped hint exactly).
	function matchCategory(hint) {
		const term = normalize(hint);
		if (!term || !categoryOptions.length || !categoryValue) return;

		let best = null;
		let bestLength = 0;
		categoryOptions.forEach(option => {
			const value = option.dataset.value || '';
			const normalized = normalize(value);
			if (!normalized) return;
			if ((term.indexOf(normalized) !== -1 || normalized.indexOf(term) !== -1) && normalized.length > bestLength) {
				best = option;
				bestLength = normalized.length;
			}
		});

		if (best) {
			categoryValue.value = best.dataset.value || '';
			if (categoryLabel) categoryLabel.textContent = best.dataset.value || '';
			categoryOptions.forEach(o => o.classList.toggle('is-active', o === best));
		}
	}

	// Fills every field except the URL itself: a visitor should always see
	// exactly the link they pasted, never see it silently replaced.
	function fillForm(data) {
		if (titleInput && data.title) titleInput.value = data.title;
		if (descriptionInput && data.description) descriptionInput.value = data.description;
		if (priceInput && data.price) priceInput.value = data.price;
		if (pricePromoInput && data.price_promotional) pricePromoInput.value = data.price_promotional;
		if (storeInput && data.store) storeInput.value = data.store;
		if (imageInput && data.images && data.images.length) imageInput.value = data.images[0];
		if (data.category) matchCategory(data.category);
	}

	function fetchProduct() {
		const url = (urlInput.value || '').trim();
		if (!url || !nonce) return;

		setStatus(fetchStatus, 'Buscando dados do produto...', false);

		const body = new URLSearchParams();
		body.append('action', 'pechincha_offer_suggest_fetch');
		body.append('nonce', nonce);
		body.append('url', url);

		fetch(config.ajax_url, {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: body.toString(),
		})
			.then(r => r.json())
			.then(res => {
				if (res.success && res.data) {
					fillForm(res.data);
					setStatus(fetchStatus, '', false);
					fetchStatus.classList.add('hidden');
				} else {
					setStatus(fetchStatus, (res.data && res.data.message) || 'Não foi possível ler dados dessa página.', true);
				}
			})
			.catch(() => setStatus(fetchStatus, 'Erro de rede ao buscar dados do produto.', true));
	}

	if (urlInput) {
		urlInput.addEventListener('input', () => {
			clearTimeout(fetchTimer);
			fetchTimer = setTimeout(fetchProduct, 600);
		});
	}

	root.addEventListener('submit', e => {
		e.preventDefault();

		if (submitButton) submitButton.disabled = true;

		const body = new URLSearchParams();
		body.append('action', 'pechincha_submit_offer');
		body.append('nonce', nonce);
		new FormData(root).forEach((value, key) => body.append(key, value));

		fetch(`${config.ajax_url}`, {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: body.toString(),
		})
			.then(r => r.json())
			.then(res => {
				if (!msg) return;
				msg.classList.remove('hidden');
				if (res.success) {
					msg.classList.remove('is-error');
					msg.textContent = (res.data && res.data.message) || 'Oferta enviada!';
					root.reset();
					if (categoryLabel) categoryLabel.textContent = categoryLabel.dataset.placeholder || categoryLabel.textContent;
					categoryOptions.forEach(o => o.classList.toggle('is-active', o.dataset.value === ''));
				} else {
					msg.classList.add('is-error');
					msg.textContent = (res.data && res.data.message) || 'Não foi possível enviar.';
				}
			})
			.catch(() => {
				if (msg) {
					msg.classList.remove('hidden');
					msg.classList.add('is-error');
					msg.textContent = 'Erro de rede. Tente de novo.';
				}
			})
			.finally(() => {
				if (submitButton) submitButton.disabled = false;
			});
	});
});
